import { Dialog } from '@progress/kendo-react-dialogs';
import React from 'react';
import { ATTRIBUTE_LABEL } from '../Helpers/Labels/AttributeLabel';
import AttributeTypes from './AttributeTypes';
import { useTranslation } from 'react-i18next';

function AttributeTypePopup(props) {
    let { excludedTypes } = props;
    let attributeTypes = AttributeTypes.Types.filter(type => !excludedTypes.includes(type.value));
    return (
        <Dialog
            title={ATTRIBUTE_LABEL + " Types"}
            onClose={props.onClose}
            width={"80%"}
            height={"90%"}
        >
            <div className="container-fluid mt-3 h-100">
                <div className="row gx-5 h-100">
                    {
                        attributeTypes.map((type, index) => (
                            <AttributeBox
                                key={index}
                                type={type}
                                onSelect={() => props.onSelect(type)} />
                        ))
                    }
                </div>
            </div>
        </Dialog>
    )
}

function AttributeBox(props) {
    const { t } = useTranslation("attribute/common");

    return (

        <div className="col-lg-6 col-md-12" style={{ height: "8em" }}>
            <div className="row">
                <div
                    className="col-2 rounded d-flex align-items-center justify-content-center"
                    style={{
                        backgroundColor: props.type.color,
                        height: "6em"
                    }}>
                    <i className={props.type.icon} style={{ fontSize: "2.5em" }} />
                </div>
                <div className="col-10">
                    <div className="row mt-2">
                        <h4 className='col-12 font-size-1 font-weight-600'>
                            {props.type.text}
                        </h4>
                    </div>
                    <div className='row'>
                        <p className='col-10 font-size-1'>
                            {props.type.description}
                        </p>
                        <div className='col-1 ps-0'>
                            <button
                                className='btn btn-outline-secondary'
                                onClick={props.onSelect}
                            >
                                {t("buttons.select", { ns: "attribute/common" })}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AttributeTypePopup;